import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "../Common/CommonStyle";
import DialogBox from "../Common/DialogBox";
export interface IPreventiveMeasures {
  displayNextSlide: () => void;
}

const PreventiveMeasures = (props: IPreventiveMeasures) => {
  const [nextSlide, showNextSlide] = React.useState(0);
  const classes = useStyles();

  const proceedClick = () => {
    showNextSlide(1);
    props.displayNextSlide();
  };

  return (
    <Box
      className={classes.positionComponent}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <DialogBox
        childProps={
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "inherit",
              width: "inherit",
            }}
          >
            <div style={{ textAlign: "center" }}>
              {" "}
              <Typography
                variant="h5"
                color="white"
                sx={{ fontWeight: "600", padding: "0.5rem 2rem 0.5rem 2rem" }}
              >
                Execute preventive
              </Typography>
              <Typography
                variant="h5"
                color="white"
                sx={{ fontWeight: "600", paddingBottom: "2rem" }}
              >
                measures?
              </Typography>
            </div>
            <Button
              sx={{
                borderRadius: "3rem",
                textTransform: "capitalize",
                padding: "1rem 1.5rem",
                fontSize: "1rem",
                fontWeight: "600",
                backgroundColor: "#56CCF2",
                width: "70%",
                color: "#004D66",
                marginBottom: "3rem",
              }}
              variant="contained"
              onClick={proceedClick}
            >
              Proceed
            </Button>
          </div>
        }
        type={1}
      />
    </Box>
  );
};

export default PreventiveMeasures;
